import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// GA4 measurement ID — must match the gtag config in public/index.html.
const GA_MEASUREMENT_ID = 'G-CPZWN9VMTE';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Fires a GA4 page_view on every client-side route change.
 *
 * This is a BrowserRouter SPA: the gtag tag in index.html only fires once, on
 * the initial hard load, so React Router navigations (Home -> Blog -> a post)
 * were invisible to analytics. The config tag has send_page_view disabled, so
 * this hook is the single source of page_view events — including the first one.
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;

    const page_path = location.pathname + location.search;
    window.gtag('event', 'page_view', {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location.pathname, location.search]);
};
